module.exports = __webpack_public_path__ + "static/img/微信图片_20220708180628.9afdeba9.png";